export default __webpack_public_path__ + "3594dc38667796ea18132854752f04b5.png";